/* eslint-disable
    no-console,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AzSearch = () => ({
   controllerAs: 'search',
   controller: AzSearchController,
   templateUrl: '/assets/azSearchWidget.html',

   bindToController: {
      fromSearchInfo: '<'
   }
})

const AzSearchResults = () => ({
   controllerAs: 'results',
   controller: AzSearchResultsController,
   templateUrl: '/assets/azSearchWidgetResults.html',

   bindToController: {
      results: '<',
      count: '<'
   }
})


class AzSearchService {
   $http: any
   acService: any
   advancedService: any
   count: any
   dataService: any
   enableAutoSearch: any
   maxResultSize: any
   retrieveAzResultsSize: any
   prev_query: any
   query: any
   results: any
   searchError: any
   searchUrl: any
   suggestUrl: any
   transformResponse: any
   constructor($http: any, acService: any, advancedService: any,  dataService: any, config: any) {
      this.onNewQuery = this.onNewQuery.bind(this)
      this.$http = $http
      this.acService = acService
      this.advancedService = advancedService
      this.dataService = dataService
      this.results = []
      this.count = -1
      this.prev_query = ''
      this.query = ''
      this.maxResultSize = +config.data.widgets.azDatabaseDefaultResults
      // for now just fix it to 8 * the maxResultSize. We don't have proper paging, so we 'in memory page' until maximally this number
      this.retrieveAzResultsSize = 8 * this.maxResultSize
      this.searchError = false
      this.transformResponse = this.acService.transformResponse
      this.suggestUrl = this.acService.getAzSearchUrl('suggest')
      this.searchUrl = this.acService.getAzSearchUrl('search')
      this.enableAutoSearch = config.data.widgets.enableAZSearchWidgetAutoSearch
      this.dataService.on('new', this.onNewQuery)
   }

   clear() {
      this.results = []
      this.count = -1
      return this.searchError = false
   }

   clearSearch() {
      this.clear()
      return this.query = ''
   }

   updateData(results: any) {
      return this.results = results
   }

   search(query: any) {
      this.query = query
      if (this.query.length === 0) {
         return // only search if there's something to search
      }

      this.prev_query = this.query
      // Reset searchError at the start of a new search
      this.searchError = false 
      //encode query to support special characters
      let encodedQuery = encodeURIComponent(this.query)
      let url_link = `${this.searchUrl}&q=${encodedQuery}&size=${this.retrieveAzResultsSize}`
      return this.$http.get(url_link)
         .then((res: any) => { 
            if (res.data !== null) {
               const results = res.data['az'].map(function(r: any) { 
                  r.search_result = true // indicator for render template display
                  return r
               })
               // new AZ endpoint has hits.value instead of 'hits' with a count. CHecking for both options in case this changes back
               if (typeof res.data['stats']['hits'] === 'number') {
                  this.count = res.data['stats']['hits']
               }
               else {
                  this.count = res.data['stats']['hits']['value']
               }
               return this.updateData(results)
            }
         }).catch((err: any) => { 
            console.error(err)
            this.clear()
            return this.searchError = true
         })
   }

   // some simple heuristics to determine if we should
   // 1. Parse advanced search queries 'TitleCombined:"(foo)"' and only use values
   // 2. Try and only grab values from index searches (that happen after clicking subject or author for example)
   // 3. Do not search very long queries
   parseQuery(q: any) {
      if (/([^:]+):\(.+?\)?/.test(q)) {
         const queryValues = this.advancedService.parseQueryToAdvancedQueryValues(q)
         if (queryValues && queryValues.length) { 
            return queryValues.join(' ')
         }
      }
      if (/([^:]+):".+?"/.test(q)) {
         const matches = q.match(/[^:]+:"([^"]+)"/)
         if (matches && matches.length) {
            return matches[1]
         } else { 
            return ''
         }
      }
      if (q.length > 150) {
         return ''
      }
      return q
   }

   onNewQuery(q: any) {
      const current_query = q.query.original_query
      if (!this.enableAutoSearch) {
         this.clear()
         return
      }

      if (this.prev_query !== current_query) { 
         this.clear()
         this.query = this.parseQuery(current_query)
         return this.search(this.query)
      }
   }
}


AzSearchService.$inject = ['$http', 'autocompleteService', 'advancedSearchService', 'dataService', 'configService']

class AzSearchController {
   $scope: any
   azBrowseUrl: any
   azService: any
   clear: any
   count: any
   maxResultSize: any
   query: any
   constructor($scope: any, azService: any, config: any) {
      this.submit = this.submit.bind(this)
      this.$scope = $scope
      this.azService = azService
      this.query = ''
      this.count = this.azService.count
      this.maxResultSize = this.azService.maxResultSize
      this.clear = this.azService.clear
      this.azBrowseUrl = config.data.widgets.azBrowseUrl
   }

   $onInit() {
      return this.$scope.$watchCollection('results', (newResults: any) => {
         return this.query = this.azService.query
      })
   }

   onResponse(json: any) {
      return this.azService.transformResponse({azSearch: json})
   }

   clearSearch(data: any) {
      this.clear()
      this.query = ''
      return this.azService.clearSearch()
   }

   onSelect(data: any) {
      this.clear()
      data.search_result = true // indicator for render template display
      this.azService.updateData([data])
      return this.$scope.$apply()
   }

   submit() {
      this.clear()
      return this.azService.search(this.query)
   }
}

AzSearchController.$inject = ['$scope', 'azSearchService', 'configService']


class AzSearchResultsController {
   $scope: any
   $window: any
   azService: any
   count: any
   maxResultSize: any
   page: any
   pageSize: any
   shouldShowNext: any
   trustAsHtml: any
   constructor($scope: any, $sce: any, $window: any, azService: any) {
      this.updatePaging = this.updatePaging.bind(this)
      this.$scope = $scope
      this.$window = $window
      this.azService = azService
      this.pageSize = Math.min(this.azService.retrieveAzResultsSize, this.azService.maxResultSize)
      this.page = 1
      this.shouldShowNext = false
      this.maxResultSize = this.azService.maxResultSize
      this.trustAsHtml = $sce.trustAsHtml
   }

   $onInit() {
      return this.$scope.$watchCollection('results.results', (newResults: any) => {
         this.updatePaging()
         if (newResults && newResults.length === 0) {
            return this.clear()
         }
      })
   }

   clear() {
      this.page = 1
      return this.shouldShowNext = false
   }

   showNextX() {
      if (this.page < (this.count / this.pageSize)) {
         this.$window.scrollTo(0,0)
         return this.updatePaging(1)
      }
   }

   showPreviousX() {
      if (this.page > 1) {
         this.$window.scrollTo(0,0)
         return this.updatePaging(-1)
      }
   }

   updatePaging(action = 0) { 
      this.page += action
      return this.shouldShowNext = this.page < (Math.min(this.count, this.azService.retrieveAzResultsSize) / this.pageSize)
   }
}


AzSearchResultsController.$inject = ['$scope', '$sce', '$window', 'azSearchService']

angular.module('summonApp.directives')
   .service('azSearchService', AzSearchService)
   .controller('azSearchResultsController', AzSearchResultsController)
   .controller('azSearchController', AzSearchController)
   .directive('azSearch', AzSearch)
   .directive('azSearchResults', AzSearchResults)

